import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarMark } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';

const SLICE_NAME = 'carMark';

export const carMarkSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarMark(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarMark });
    },
});

export const { clearCarMark } = carMarkSlice.actions;

export const mark = carMarkSlice.reducer;
